import { ComponentInstance } from '@uniformdev/canvas';

// Util function to transform the nav item data for the side nav link component
// to be used in the side nav component and side nav collection component

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformNavItemData = (slots: any) => {
	return slots.map((childComponent: ComponentInstance) => {
		const childProps = childComponent.parameters ?? {};
		if (childComponent.type === 'sideNavLink') {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const anchors = childProps['anchors']?.value as any[];
			return {
				type: 'link',
				text: childProps['text']?.value as string,
				href: childProps['href']?.value as string,
				anchors: anchors
					? anchors.map((anchor) => {
							return {
								text: anchor?.fields?.text?.value,
								id: anchor?.fields?.id?.value,
							};
						})
					: null,
				dataEventProps: {
					'data-product-key': 'uniform',
					'data-event-component': 'linkButton',
					'data-event-container': 'sideNav',
					'data-event': 'clicked',
				},
			};
		}
		if (childComponent.type === 'sideNavCollection') {
			return {
				type: 'collection',
				collectionName: childProps['collectionName']?.value as string,
				sideNavItems: transformNavItemData(childComponent.slots?.['sideNavItems']),
			};
		}
		return;
	});
};
